import {useLazyQuery} from '@apollo/client/react';
import {extractGqlData} from '@coolcolduk/ui-apollo-client';
import {COUNT_QUESTIONS_BY_SEED_QUESTION} from '../sharedQueries';

export function useCountQuestionsBySeedQuestion() {
  const [countQuestionsBySeedQuestionQuery, {loading, error}] = useLazyQuery<
    {countQuestionsBySeedQuestion: number},
    {moduleId: string; seedQuestionId: string}
  >(COUNT_QUESTIONS_BY_SEED_QUESTION);

  const countQuestionsBySeedQuestion = async (moduleId: string, seedQuestionId: string) => {
    const result = await countQuestionsBySeedQuestionQuery({
      variables: {
        moduleId,
        seedQuestionId,
      },
    });

    return extractGqlData(result).countQuestionsBySeedQuestion;
  };

  return {
    countQuestionsBySeedQuestion,
    loading,
    error,
  };
}
